import { render, staticRenderFns } from "./TicketCreateModal.vue?vue&type=template&id=efad7b20&scoped=true&"
import script from "./TicketCreateModal.vue?vue&type=script&lang=ts&"
export * from "./TicketCreateModal.vue?vue&type=script&lang=ts&"
import style0 from "./TicketCreateModal.vue?vue&type=style&index=0&id=efad7b20&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "efad7b20",
  null
  
)

/* vuetify-loader */
import installComponents from "!../../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCol } from 'vuetify/lib/components/VGrid';
import { VContainer } from 'vuetify/lib/components/VGrid';
import { VFadeTransition } from 'vuetify/lib/components/transitions';
import { VRow } from 'vuetify/lib/components/VGrid';
installComponents(component, {VCol,VContainer,VFadeTransition,VRow})


/* hot reload */
if (module.hot) {
  var api = require("C:\\Users\\javie\\Documents\\Javier\\Developer\\Landing Dayco\\dayco-cportal-app-client\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('efad7b20')) {
      api.createRecord('efad7b20', component.options)
    } else {
      api.reload('efad7b20', component.options)
    }
    module.hot.accept("./TicketCreateModal.vue?vue&type=template&id=efad7b20&scoped=true&", function () {
      api.rerender('efad7b20', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/modules/tickets/dashboard/components/TicketCreateModal.vue"
export default component.exports